import {
	CHAT,
	SAVE_MESSAGES,
	RETRIEVE_MESSAGES,
	LOADING,
	KEY_BY_ASPNETCOMPANYID_EMPLOYEEID
} from './chat-mutation-types';
import api from '@/services/ai-api-service';
import { isEmpty } from 'lodash';

export default {
	name: 'chat',
	namespaced: true,
	strict: process.env.NODE_ENV !== 'production',
	state: {
		[CHAT]: [],
		[LOADING]: false,
		[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID]: ''
	},

	mutations: {
		[SAVE_MESSAGES](state, messages) {
			state[CHAT] = messages;
		},
		[LOADING](state, value) {
			state[LOADING] = value;
		},
		[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID](state, value) {
			state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID] = value;
		}
	},
	actions: {
		Init({ commit, dispatch, state, rootGetters }, customErrorHandler) {
			if (!state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID]) {
				const { AspNetCompaniesId, EmployeeId } = rootGetters[
					'user/userInfo'
				];

				const CHAT_MESSAGE_KEY = `CHAT_MESSAGE_${`${AspNetCompaniesId}_${EmployeeId}`}`;

				commit(KEY_BY_ASPNETCOMPANYID_EMPLOYEEID, CHAT_MESSAGE_KEY);
			}

			const hasLocalStorageMessages =
				localStorage.getItem(
					state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID]
				) !== null;

			const hasVueStoreMessages = !isEmpty(state[CHAT]);

			if (hasLocalStorageMessages) {
				const storedMessageString = localStorage.getItem(
					state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID]
				);
				commit(SAVE_MESSAGES, JSON.parse(storedMessageString));
				return;
			}
			if (hasVueStoreMessages) {
				localStorage.setItem(
					state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID],
					JSON.stringify(state[CHAT])
				);
				return;
			}
			dispatch(RETRIEVE_MESSAGES, {
				message: null,
				customErrorHandler
			});
		},
		async [RETRIEVE_MESSAGES](
			{ commit, state },
			{ message, customErrorHandler }
		) {
			//store message
			const lastId = state[CHAT].reduce(
				(maxId, msg) => Math.max(maxId, msg.id || 0),
				0
			);
			if (message) {
				const objMessage = {
					content: message,
					role: {
						label: 'user'
					},
					timestamp: new Date().toISOString(),
					id: lastId + 1
				};

				const updatedMessages = [...state[CHAT], objMessage];
				commit(SAVE_MESSAGES, updatedMessages);

				localStorage.setItem(
					state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID],
					JSON.stringify(updatedMessages)
				);
			}

			//ignore error message when we send message history
			let historyChatMessage = [];

			if (!isEmpty(state[CHAT])) {
				historyChatMessage = state[CHAT].filter(
					message => message.role.label !== 'system-error'
				);
			}

			// loading in true
			commit(LOADING, true);

			await api
				.post(
					'/assistant/Chat',
					{ messages: historyChatMessage },
					customErrorHandler
				)
				.then(response => {
					if (!isEmpty(response)) {
						const { messages } = response;

						if (!isEmpty(messages)) {
							commit(SAVE_MESSAGES, messages);
							localStorage.setItem(
								state[KEY_BY_ASPNETCOMPANYID_EMPLOYEEID],
								JSON.stringify(messages)
							);
						}
					}
				});

			// loading in false
			commit(LOADING, false);
		}
	},
	getters: {
		[CHAT]: state => state[CHAT],
		[LOADING]: state => state[LOADING]
	}
};
